import { Sidebar } from 'semantic-ui-react';

export default Sidebar;
